import { ArrowBackOutlined } from "@material-ui/icons";
import { Link, useLocation } from "react-router-dom";

export default function ShowProfile() {
  const location = useLocation();
  const el = location.el;
  return (
    <div>
      <Link to="/teacher/studentsList">
        <div className="back">
          <ArrowBackOutlined />
          GoToBack
        </div>
      </Link>
      <div className="card">
        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIfoU4jaP_y6-LiF2sKa3Etmyw4xSHY7n8PA&usqp=CAU" alt="" style={{ width: "100%" }} />
        <h3>{el.firstName} {el.lastName}</h3>
        <h4 className="title">{el.username}</h4>
        <p className="title">{el.email}</p>
        
      </div>
    </div>
  );
}
